import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * Created by cweikart on 12/13/2016.
 */

// I was tempted to make this immutable, but in-place operations avoid allocation, so efficiency wins.

export class Rectangle {
  constructor(left, top, right, bottom) {
    _defineProperty(this, "_left", void 0);
    _defineProperty(this, "_top", void 0);
    _defineProperty(this, "_right", void 0);
    _defineProperty(this, "_bottom", void 0);
    this._left = left;
    this._top = top;
    this._right = right;
    this._bottom = bottom;
  }
  static from(that) {
    return new Rectangle(that.left, that.top, that.right, that.bottom);
  }
  get isValid() {
    return this.left <= this.right && this.top <= this.bottom;
  }
  get left() {
    return this._left;
  }
  set left(value) {
    this._left = value;
  }
  get top() {
    return this._top;
  }
  set top(value) {
    this._top = value;
  }
  get right() {
    return this._right;
  }
  set right(value) {
    this._right = value;
  }
  get bottom() {
    return this._bottom;
  }
  set bottom(value) {
    this._bottom = value;
  }
  get width() {
    return this.right - this.left;
  }
  get height() {
    return this.bottom - this.top;
  }
  get center() {
    return {
      x: this.left + this.width / 2,
      y: this.top + this.height / 2
    };
  }
  equals(that) {
    return this.left === that.left && this.top === that.top && this.right === that.right && this.bottom === that.bottom;
  }

  // In order to avoid allocation, the following methods operate in-place.
  // Each method nevertheless returns 'this' in order to support pipelines, a la
  // r.translate(-r.center.x, -r.center.y).scale(2, 2).translate(r.center.x, r.center.y);

  /**
   * Be aware that translate modifies the rectangle, and returns itself in order to support pipelines.
   */
  translate(x, y) {
    this.left += x;
    this.top += y;
    this.right += x;
    this.bottom += y;
    return this;
  }

  /**
   * Be aware that scale modifies the rectangle, and returns itself in order to support pipelines.
   */
  scale(x, y) {
    this.left *= x;
    this.top *= y;
    this.right *= x;
    this.bottom *= y;
    return this;
  }

  /**
   * Be aware that union modifies the rectangle, and returns itself in order to support pipelines.
   */
  union(that) {
    return this.ops(that, Math.min, Math.min, Math.max, Math.max);
  }

  /**
   * Be aware that intersection modifies the rectangle, and returns itself in order to support pipelines.
   * @param that
   */
  intersection(that) {
    return this.ops(that, Math.max, Math.max, Math.min, Math.min);
  }

  /**
   * Returns true if the specified rectangle is completely within the bounds of this.
   */
  contains(rectangle) {
    return Rectangle.from(this).intersection(rectangle).equals(rectangle);
  }

  /**
   * Returns true if the point lies inside the bounds of this Rectangle.
   * @param x
   * @param y
   */
  hitTest(x, y) {
    return x >= this.left && x <= this.right && y >= this.top && y <= this.bottom;
  }
  toString() {
    return `{left: ${this.left}, top: ${this.top}, right: ${this.right}, bottom: ${this.bottom}}`;
  }
  ops(that, leftOp, topOp, rightOp, bottomOp) {
    this.left = leftOp(this.left, that.left);
    this.top = topOp(this.top, that.top);
    this.right = rightOp(this.right, that.right);
    this.bottom = bottomOp(this.bottom, that.bottom);
    return this;
  }
}
//# sourceMappingURL=Rectangle.js.map
